import React from "react";
import { Link, useNavigate } from "react-router-dom";
import DeferredCommission from "./DeferredCommission";

const DeferredCommissionList = () => {
  //const navigate = useNavigate();

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed overlapping">
        <div className="content__wrap">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="./index.html">Home</a>
              </li>
              <li className="breadcrumb-item">Commissions</li>
              <li className="breadcrumb-item active" aria-current="page">
                Deferred
              </li>
            </ol>
          </nav>

          <h1 className="page-title mb-0 mt-2">Deferred Commission List</h1>

          <p className="lead">View all deferred commissions</p>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <div className="tab-base1">
            <ul className="nav nav-tabs mb-2" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  //onClick={() => navigate("/commissions/deferred/pending")}
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsPending"
                  type="button"
                  role="tab"
                  aria-controls="pending"
                  aria-selected="true"
                >
                  <Link to="/commissions/deferred/pending" className="btn-link">
                    Pending
                  </Link>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsDecline"
                  type="button"
                  role="tab"
                  aria-controls="decline"
                  aria-selected="false"
                >
                  <Link
                    to="/commissions/deferred/declined"
                    className="btn-link"
                  >
                    Declined
                  </Link>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#_dm-tabsAll"
                  type="button"
                  role="tab"
                  aria-controls="all"
                  aria-selected="false"
                >
                  <Link
                    to="/commissions/deferred/approved"
                    className="btn-link"
                  >
                    Approved
                  </Link>
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div
                id="_dm-tabsPending"
                className="tab-pane fade active show"
                role="tabpanel"
                aria-labelledby="pending-tab"
              >
                <DeferredCommission key={"pending"} />
              </div>
              <div
                id="_dm-tabsDecline"
                className="tab-pane fade"
                role="tabpanel"
                aria-labelledby="decline-tab"
              >
                <DeferredCommission key={"decline"} />
              </div>
              <div
                id="_dm-tabsAll"
                className="tab-pane fade"
                role="tabpanel"
                aria-labelledby="all-tab"
              >
                <DeferredCommission key={"approved"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeferredCommissionList;
